module.exports = __webpack_public_path__ + "img/pos1-bg.923e2350.jpg";